<div class="main-container-position">
  <div class="container-width">
    <div class="container mx-auto p-8">
      <div class="mb-6">
        <h1 class="text-2xl font-bold text-left text-gray-800 mb-2" i18n>
          Datei Upload für Angebote
        </h1>
        <p class="text-left" i18n>
          Hier kannst du mehrere Angebot zu einer Auswahl an Kategorien
          hinzufügen. Bitte fülle die Excel-Vorlage mit den Angeboten aus, die
          Angebote werden an den Fachbeirat zur Überprüfung weitergeleitet.
        </p>
        <button
          (click)="downloadTemplate()"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full mt-4"
          i18n
          >
          Excel-Vorlage herunterladen
        </button>
      </div>

      <div class="flex flex-col md:flex-row md:space-x-6 mt-6">
        <div class="flex-1">
          <label
            for="fileInput"
            class="block text-sm font-medium text-gray-700 mb-2"
            i18n
            >Excel-Datei Upload</label
            >
            <input
              type="file"
              (change)="onFileChange($event)"
              class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
          </div>

          <div class="flex-1 mt-4 md:mt-0">
            <label
              for="categories"
              class="block text-sm font-medium text-gray-700 mb-2"
              i18n
              >Kategorien auswählen</label
              >
              <mat-form-field class="w-full">
                <input
                  type="text"
                  placeholder="Kategorien hinzufügen"
                  matInput
                  [formControl]="searchControl"
                  [matAutocomplete]="autoCategory"
                  />
                <mat-autocomplete
                  #autoCategory="matAutocomplete"
                  (optionSelected)="addCategory($event.option.value)"
                  >
                  @for (category of filteredCategories | async; track category) {
                    <mat-option
                      [value]="category"
                      >
                      {{ category.name }}
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>

              <!-- Display Selected Categories -->
              <div class="flex flex-wrap gap-2 mt-4">
                @for (category of selectedCategories; track category) {
                  <span
                    class="flex items-center bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full"
                    >
                    {{ category.name }}
                    <button
                      (click)="removeCategory(category)"
                      class="ml-2 text-black hover:text-gray-700 focus:outline-none text-xs flex items-center justify-center w-4 h-4"
                      >
                      <span class="material-symbols-outlined text-xs mt-0.5"
                        >close</span
                        >
                      </button>
                    </span>
                  }
                </div>
              </div>
            </div>

            <div class="flex justify-end items-center mt-8 space-x-4">
              <button
                routerLink="/company"
                class="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-6 rounded-full"
                i18n
                >
          Abbrechen
        </button>
              <button
                (click)="uploadFile()"
                class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-6 rounded-full"
                type="button"
                i18n
                >
          Angebote einreichen
        </button>
            </div>
          </div>
        </div>
      </div>
